/**
 * Same role as `fusion-shell/src/frontend-router/frontend-router-setup.ts`:
 * set `__INFIELD_BUILD_VERSION__` and `history.replaceState` from `originalPath`
 * when loaded from `/_static/index_<hash>.html`.
 *
 * The logic is extracted to a separate function to make it easier to test.
 */
import { applyInfieldFrontendRouterSetup } from './apply-infield-frontend-router-setup';
import { applyInfieldProjectPathSetup } from './apply-infield-project-path-setup';

applyInfieldFrontendRouterSetup(window);
applyInfieldProjectPathSetup(window);
